import { lazy } from "react"

export const AuthorizationErrorPage = lazy(() => import("./AuthorizationErrorPage"))
